export class BaseTip {
	id: string;
	eventId: string;
	value: number;
}